// Dinamik grup kriter sözlüğü — TEK KAYNAK.
//
// Hem kriter kurucusu (GroupCriteriaBuilder) hem üye sekmesinin özet bandı
// (GroupUsersTab) buradan okur. İkisinde ayrı sözlük tutulursa aynı kriter iki
// yerde farklı okunur; bu dosya o ayrışmayı imkânsız kılıyor.
//
// Numaralar backend'in DynamicGroupCriterionTypes sabitleriyle BİREBİR aynıdır ve
// AssignmentScopeTarget.AssignmentType ile kasten hizalıdır. 3 (Grup) ve 4 (Kullanıcı)
// YASAK olduğu için burada hiç yoktur.
export const CRITERION = {
  DEPARTMENT: 1,
  LOCATION: 2,
  SUB_TENANT: 5,
  TITLE: 6,
  COLLAR_TYPE: 7,
  EMPLOYMENT_TYPE: 8,
  POSITION: 9,
  GENDER: 10,
  MARITAL_STATUS: 11,
  NATIONALITY: 12,
  EMPLOYMENT_DATE: 13,
  SENIORITY_MONTHS: 14,
  NUMBER_OF_CHILDREN: 15,
  DATE_OF_BIRTH: 16,
  // Yaş doğum tarihinden TÜRETİLİR (backend okuma anında sınıra çevirir).
  AGE: 17,
  // Personel statüsü (AKM POC §6.1) — Employee.EmployeeStatusId, kimlikle (targetId) ifade edilir.
  EMPLOYEE_STATUS: 18,
  // İş mimarisi: ünvanın kademesi (SIRALI — En Az/En Çok hedefin güncel seviyesine göre) ve iş ailesi.
  // Yeni kriter 21'den başlar.
  GRADE: 19,
  JOB_FAMILY: 20,
};

export const OP = { EQ: 0, GTE: 1, LTE: 2 };

// Backend'in DynamicGroupCriterionTypes.AllowsOperator'ıyla AYNI kural. Ayrışırsa
// kullanıcı ekranda kaydedemediği bir kombinasyon kurar.
const ALLOWED_OPS = {
  [CRITERION.DEPARTMENT]: [OP.EQ],
  [CRITERION.LOCATION]: [OP.EQ],
  [CRITERION.SUB_TENANT]: [OP.EQ],
  [CRITERION.TITLE]: [OP.EQ],
  [CRITERION.COLLAR_TYPE]: [OP.EQ],
  [CRITERION.EMPLOYMENT_TYPE]: [OP.EQ],
  [CRITERION.POSITION]: [OP.EQ],
  [CRITERION.GENDER]: [OP.EQ],
  [CRITERION.MARITAL_STATUS]: [OP.EQ],
  [CRITERION.NATIONALITY]: [OP.EQ],
  [CRITERION.EMPLOYMENT_DATE]: [OP.GTE, OP.LTE],
  [CRITERION.SENIORITY_MONTHS]: [OP.GTE, OP.LTE],
  [CRITERION.NUMBER_OF_CHILDREN]: [OP.EQ, OP.GTE, OP.LTE],
  [CRITERION.DATE_OF_BIRTH]: [OP.GTE, OP.LTE],
  [CRITERION.AGE]: [OP.GTE, OP.LTE],
  [CRITERION.EMPLOYEE_STATUS]: [OP.EQ],
  [CRITERION.GRADE]: [OP.EQ, OP.GTE, OP.LTE],
  [CRITERION.JOB_FAMILY]: [OP.EQ],
};

export const ENTITY_TYPES = [
  CRITERION.DEPARTMENT, CRITERION.LOCATION, CRITERION.SUB_TENANT,
  CRITERION.TITLE, CRITERION.POSITION, CRITERION.EMPLOYEE_STATUS, CRITERION.GRADE, CRITERION.JOB_FAMILY,
];
export const DATE_TYPES = [CRITERION.EMPLOYMENT_DATE, CRITERION.DATE_OF_BIRTH];
export const NUMBER_TYPES = [
  CRITERION.SENIORITY_MONTHS, CRITERION.NUMBER_OF_CHILDREN, CRITERION.AGE,
];
export const ENUM_TYPES = [
  CRITERION.COLLAR_TYPE, CRITERION.EMPLOYMENT_TYPE,
  CRITERION.GENDER, CRITERION.MARITAL_STATUS,
];

// Sayısal kriterlerin SINIRLARI — backend UserGroupCriteriaValidator'daki
// aralıkla BİREBİR aynı olmak zorunda. Ayrışırsa kullanıcı ekranda girebildiği
// bir değerle 400 alır ve nedenini göremez.
export const NUMBER_RANGE = {
  [CRITERION.AGE]: { min: 0, max: 120 },
  [CRITERION.SENIORITY_MONTHS]: { min: 0, max: 1200 },
  [CRITERION.NUMBER_OF_CHILDREN]: { min: 0, max: 50 },
};

export const numberRange = (tip) => NUMBER_RANGE[tip] || { min: 0, max: undefined };

export const allowedOperators = (tip) => ALLOWED_OPS[tip] || [OP.EQ];

export const firstOperator = (tip) => allowedOperators(tip)[0];

// Tip değişince ESKİ DEĞER TEMİZLENİR; yoksa "yaka tipi = <departman kimliği>" gibi
// kaydedilemeyen bir satır kalır ve kullanıcı hatanın nerede olduğunu göremez.
export const emptyValue = () => ({
  targetId: null, valueInt: null, valueDate: null, valueText: null,
});

// i18n anahtar ekleri (userGroup.criterion.<ek>).
export const CRITERION_KEYS = {
  [CRITERION.DEPARTMENT]: 'department',
  [CRITERION.LOCATION]: 'location',
  [CRITERION.SUB_TENANT]: 'subTenant',
  [CRITERION.TITLE]: 'title',
  [CRITERION.COLLAR_TYPE]: 'collarType',
  [CRITERION.EMPLOYMENT_TYPE]: 'employmentType',
  [CRITERION.POSITION]: 'position',
  [CRITERION.GENDER]: 'gender',
  [CRITERION.MARITAL_STATUS]: 'maritalStatus',
  [CRITERION.NATIONALITY]: 'nationality',
  [CRITERION.EMPLOYMENT_DATE]: 'employmentDate',
  [CRITERION.SENIORITY_MONTHS]: 'seniorityMonths',
  [CRITERION.NUMBER_OF_CHILDREN]: 'numberOfChildren',
  [CRITERION.DATE_OF_BIRTH]: 'dateOfBirth',
  [CRITERION.AGE]: 'age',
  [CRITERION.EMPLOYEE_STATUS]: 'employeeStatus',
  [CRITERION.GRADE]: 'grade',
  [CRITERION.JOB_FAMILY]: 'jobFamily',
};

// Enum değerlerinin çeviri anahtarları — çalışan formundaki sözlüklerle AYNI.
export const ENUM_LABEL_KEYS = {
  [CRITERION.COLLAR_TYPE]: { 1: 'employee.whiteCollar', 2: 'employee.blueCollar' },
  [CRITERION.EMPLOYMENT_TYPE]: { 1: 'employee.fullTime', 2: 'employee.partTime', 3: 'employee.contract' },
  [CRITERION.GENDER]: { 1: 'employee.male', 2: 'employee.female', 3: 'employee.preferNotToSay' },
  [CRITERION.MARITAL_STATUS]: { 1: 'employee.married', 2: 'employee.single', 3: 'employee.divorced' },
};

export const criterionTypeLabel = (tip, t) =>
  t(`userGroup.criterion.${CRITERION_KEYS[tip] || 'unknown'}`);

// TARİH tiplerinde "En Az/En Çok" TERS OKUNUR: "En Az 1976" = 1976'dan SONRA
// doğmuş, yani DAHA GENÇ. Kullanıcı bunun tersini bekler. Bu yüzden tarih
// kriterlerinde operatör "Şu tarihten sonra / önce" diye adlandırılır; sayısal
// tiplerde (yaş, kıdem, çocuk) "En Az/En Çok" doğru okunur ve korunur.
export const operatorLabel = (op, t, tip = null) => {
  const tarihMi = tip !== null && DATE_TYPES.includes(tip);
  if (op === OP.GTE) return t(tarihMi ? 'userGroup.operator.dateAfter' : 'userGroup.operator.gte');
  if (op === OP.LTE) return t(tarihMi ? 'userGroup.operator.dateBefore' : 'userGroup.operator.lte');
  return t('userGroup.operator.eq');
};

// Kriter satırını insan okunur tek satıra çevirir (üye sekmesindeki özet rozeti).
export function criterionSummary(k, t) {
  const tipAdi = criterionTypeLabel(k.criterionType, t);
  const op = k.operator === OP.GTE ? ' ≥ ' : k.operator === OP.LTE ? ' ≤ ' : ': ';

  let deger = k.targetName || k.valueText || '';

  if (!deger && ENUM_LABEL_KEYS[k.criterionType] && k.valueInt != null) {
    const anahtar = ENUM_LABEL_KEYS[k.criterionType][k.valueInt];
    deger = anahtar ? t(anahtar) : String(k.valueInt);
  }
  if (!deger && k.valueInt != null) deger = String(k.valueInt);
  if (!deger && k.valueDate) deger = String(k.valueDate).slice(0, 10);

  return `${tipAdi}${op}${deger}`;
}
